module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/antoinette-mccurdy-f1f417cf13a91261f6949898f711bca6.jpg";